/* eslint-disable @angular-eslint/component-class-suffix */
import { Component, ChangeDetectionStrategy } from '@angular/core';
import { Router } from '@angular/router';

@Component({
    templateUrl: './not-found-page.container.html',
    styleUrls: ['./not-found-page.container.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class NotFoundPageContainer {
  type = '404';
  title = 'Pagina non trovata';
  desc = 'La pagina richiesta non esiste.';

  constructor(private router: Router) {}

  back() {
    this.router.navigateByUrl('');
  }
}
